<template>
  <div class="content">
    <!-- Snackbars -->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color="primary">
      {{ alert_msg }}
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color="red">
      {{ alert_msg }}
    </v-snackbar>
    <!-- Toolbar -->
    <v-toolbar flat>
      <v-toolbar-title>
        <v-icon class="mr-2">mdi-timer-outline</v-icon>
        {{ this.$store.state.title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        class="mr-4"
      ></v-text-field>
      <v-btn color="primary" small rounded @click="openDialog">
        Add Job
        <v-icon class="ml-2">mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="schedule"
      :search="search"
      class="mt-4"
    >
      <template v-slot:item.IS_ACTIVE="{ item }">
        <v-chip :color="item.IS_ACTIVE == 1 ? 'green' : 'red'" text-color="white" small>
          {{ item.IS_ACTIVE == 1 ? 'Enabled' : 'Disabled' }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogDelete" width="330px"> 
      <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
        <v-avatar class="color-avatar3 my-4" size="62">
          <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
        </v-avatar>
        <div class="text-center text-h6 align-center justify-center font-weight-medium">
          Confirm Deletion
        </div>
        <v-card-text class="align-center justify-center mt-2">
          Are you sure you want to permanently delete this item?
        </v-card-text>
        <v-divider class="mt-4" style=""></v-divider>
        <v-card-actions class="align-center justify-center">
          <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
            OK
          </v-btn>
          <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Form -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-text-field label="Job Name" v-model="form.JOB_NAME" outlined dense></v-text-field>
          <v-text-field label="Target URL" v-model="form.TARGET_URL" outlined dense></v-text-field>
          <v-text-field label="Description" v-model="form.DESCRIPTION" outlined dense></v-text-field>
          <v-select
            :items="['GET','POST','PUT','DELETE']"
            label="Method"
            v-model="form.METHOD"
            outlined
            dense
          ></v-select>
          <v-select
            :items="scheduleTypeItems"
            item-text="text"
            item-value="value"
            label="Tipe Jadwal"
            v-model="form.SCHEDULE_TYPE"
            outlined
            dense
          ></v-select>
          <v-select
            v-if="form.SCHEDULE_TYPE === 'weekly'"
            :items="dayItems"
            item-text="text"
            item-value="value"
            label="Hari Eksekusi"
            v-model="form.DAY_OF_WEEK"
            outlined
            dense
          ></v-select>
          <v-text-field
            ref="datetime"
            v-model="form.TIME"
            label="Jam Eksekusi"
            prepend-icon="mdi-clock-outline"
            outlined
            dense
            readonly
          ></v-text-field>
          <v-text-field
            v-model="form.CRON_EXPRESSION"
            label="Cron Expression"
            prepend-icon="mdi-code-tags"
            outlined
            dense
            readonly
          ></v-text-field>
          <v-select
            :items="statusItems"
            item-text="text"
            item-value="value"
            label="Status"
            v-model="form.IS_ACTIVE"
            outlined
            dense
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import { decryptionData } from '@/components/utils/utils.js';
export default {
  data() {
    return {
      search: "",
      dialog: false,

      timeTemp: null,
      alertSuccess: false,
      alertFailed: false,
      alert_msg: "",

      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,

      dialogDelete: false,
      id_data: '',


      schedule: [],
      headers: [
        { text: "Job Name", value: "JOB_NAME" },
        { text: "Target URL", value: "TARGET_URL" },
        { text: "Method", value: "METHOD" },
        { text: "Cron", value: "CRON_EXPRESSION" },
        { text: "Description", value: "DESCRIPSTION" },
        { text: "Status", value: "IS_ACTIVE" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      statusItems: [
        { value: 1, text: "Enabled" },
        { value: 0, text: "Disabled" },
      ],

      scheduleTypeItems: [
        { value: "hourly", text: "Per Jam" },
        { value: "weekly", text: "Per Minggu" },
      ],

      dayItems: [
        { value: 0, text: "Minggu" },
        { value: 1, text: "Senin" },
        { value: 2, text: "Selasa" },
        { value: 3, text: "Rabu" },
        { value: 4, text: "Kamis" },
        { value: 5, text: "Jumat" },
        { value: 6, text: "Sabtu" },
      ],

      form: {
        ID: null,
        JOB_NAME: "",
        DESCRIPTION: "",
        TARGET_URL: "",
        METHOD: "GET",
        SCHEDULE_TYPE: "hourly",
        DAY_OF_WEEK: 1,
        TIME: "",
        CRON_EXPRESSION: "",
        IS_ACTIVE: 1,
      },

      edited: false,
      menuTime: false,
    };
  },

  computed: {
    formTitle() {
      return this.edited ? "Edit Schedule" : "Add Schedule";
    },
  },

  created() {
    this.initialize();
  },


  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.initFlatpickr();
        });
      }
    },
    "form.SCHEDULE_TYPE"() {
      this.updateCronExpression();
    },
    "form.DAY_OF_WEEK"() {
      this.updateCronExpression();
    }
  },

  methods: {
    initFlatpickr() {
      const input = this.$refs.datetime.$el.querySelector("input");
      if (!input) return;
      if (this.fp) {
        this.fp.destroy();
      }
      this.fp = flatpickr(input, {
        enableTime: true,
        noCalendar: true,
        enableSeconds: true,
        time_24hr: true,
        dateFormat: "H:i:S",
        appendTo: this.$refs.datetime.$el,
        positionElement: input,
        static: true,
        onChange: (selectedDates, dateStr) => {
          this.form.TIME = dateStr;
          this.updateCronExpression();
        },
      });
      input.addEventListener("focus", () => {
        this.fp.open();
      });
    },
    updateCronExpression() {
      if (!this.form.TIME) {
        this.form.CRON_EXPRESSION = "";
        return;
      }
      const [h, m, s] = this.form.TIME.split(":");
      const dayOfWeek =
        this.form.SCHEDULE_TYPE === "weekly"
          ? this.form.DAY_OF_WEEK
          : "*";
      this.form.CRON_EXPRESSION = `${s} ${m} ${h} * * ${dayOfWeek}`;
    },
    initialize () {
      this.tableLoading = true;
      axios.get("schedule",
        { headers:{'auth-token':localStorage.getItem('token_app')}},
        {dataType: 'json'}
        ).then((response) => {
          const data_dec = decryptionData(response.data.token);
          this.schedule = data_dec;
          // auth action  
          if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
          if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
          if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
          if(localStorage.getItem('authactview') == 1){ this.viewact = true }   
          setTimeout(() =>{
            this.loading = false
          },1000)
          this.tableLoading = false;
        })
        .catch((e) => {
            switch (e.response.status) {
                case 404:
                      this.$refs.alert.error_login(404);
                    break;
                case 403:
                      this.$refs.alert.error_login(403);
                    break;
                default:
                    console.log('some other error');  // end up here all the time
                    break;
            }
        this.errors=e.response.data.msg;
      });
      
    },
    openDialog() {
      this.dialog = true;
      this.resetForm();
    },
    closeDialog() {
      this.dialog = false;
    },
    resetForm() {
      this.form = {
        ID: null,
        JOB_NAME: "",
        DESCRIPTION: "",
        TARGET_URL: "",
        METHOD: "GET",
        SCHEDULE_TYPE: "hourly",
        DAY_OF_WEEK: 1,
        TIME: "",
        CRON_EXPRESSION: "",
        IS_ACTIVE: 1,
      };
      this.edited = false;
    },
    editItem(item) {
      this.form = {
        ...item,
        SCHEDULE_TYPE: "hourly",
        DAY_OF_WEEK: 1,
        TIME: "",
      };
      if (item.CRON_EXPRESSION) {
        const parts = item.CRON_EXPRESSION.trim().split(/\s+/);
        if (parts.length === 6) {
          const second = parts[0];
          const minute = parts[1];
          const hour = parts[2];
          const dayOfWeek = parts[5];
          this.form.TIME = `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}:${second.padStart(2, "0")}`;
          if (dayOfWeek !== "*") {
            this.form.SCHEDULE_TYPE = "weekly";
            if (/^\d+$/.test(dayOfWeek)) {
              this.form.DAY_OF_WEEK = Number(dayOfWeek);
            }
          }
        }
      }
      this.edited = true;
      this.dialog = true;
      this.$nextTick(() => {
        if (this.fp && this.form.TIME) {
          this.fp.setDate(this.form.TIME, true);
        }
      });
    },
    save() {
      if (this.edited) {
        axios
          .put("/schedule/update", {
            id: this.form.ID,
            job_name: this.form.JOB_NAME,
            description: this.form.DESCRIPTION,
            target_url: this.form.TARGET_URL,
            method: this.form.METHOD,
            cron_expression: this.form.CRON_EXPRESSION,
            is_active: this.form.IS_ACTIVE,
          })
          .then((res) => {
            if (res.data.status !== 200) {
              this.alertFailed = true;
              this.alert_msg = res.data.msg || "Update Failed";
              return;
            }
            this.alertSuccess = true;
            this.alert_msg = "Update Success";
            this.initialize();
            this.closeDialog();
          })
          .catch((err) => {
            console.error(err);
            this.alertFailed = true;
            this.alert_msg = "Update Failed";
          });
      } else {
        axios
          .post("/schedule/insert", {
            job_name: this.form.JOB_NAME,
            description: this.form.DESCRIPTION,
            target_url: this.form.TARGET_URL,
            method: this.form.METHOD,
            cron_expression: this.form.CRON_EXPRESSION,
            is_active: this.form.IS_ACTIVE,
          })
          .then((res) => {
            if (res.data.status !== 200) {
              this.alertFailed = true;
              this.alert_msg = res.data.msg || "Insert Failed";
              return;
            }
            this.alertSuccess = true;
            this.alert_msg = "Insert Success";
            this.initialize();
            this.closeDialog();
          })
          .catch((err) => {
            console.error(err);
            this.alertFailed = true;
            this.alert_msg = "Insert Failed";
          });
      }
    },
    deleteItem (item) {
      console.log(item)
      this.id_data = item.ID
      this.dialogDelete = true
    },
    closeDelete () {
      this.id_data = ''
      this.dialogDelete = false
    },
    deleteItemConfirm() {
      axios
        .delete("/schedule/delete", { data: { id: this.id_data  } })
        .then(() => {
          this.alertSuccess = true;
          this.alert_msg = "Delete Success";
          this.dialogDelete = false

          this.initialize();
        })
        .catch((err) => {
          console.error(err);
          this.alertFailed = true;
          this.alert_msg = "Delete Failed";
        });
    },
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 16px;
}
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>
